export default function Finish() {
    return (
        <div>
            <h2>Finish View</h2>
        </div>
    );
}